import * as React from 'react';
import { View } from 'react-native';

import type { RoutePlannerMapProps } from './route-planner-map.types';

type MapComponent = React.ComponentType<RoutePlannerMapProps>;

export function RoutePlannerMap(props: RoutePlannerMapProps) {
  const [PlannerMap, setPlannerMap] = React.useState<MapComponent | null>(null);

  React.useEffect(() => {
    let active = true;
    void import('./route-planner-map-leaflet').then((module) => {
      if (active) setPlannerMap(() => module.RoutePlannerMapLeaflet);
    });
    return () => {
      active = false;
    };
  }, []);

  return PlannerMap ? <PlannerMap {...props} /> : <View className="h-full w-full bg-muted" />;
}
